import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container full-height" }
const _hoisted_2 = { class: "row justify-content-center align-items-center full-height" }
const _hoisted_3 = { class: "col-md-6 col-sm container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "row justify-content-end mt-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col warning-message text-center" }
const _hoisted_11 = {
  key: 0,
  class: "success-overlay"
}
const _hoisted_12 = { class: "success-modal" }
const _hoisted_13 = { class: "countdown-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordInput = _resolveComponent("PasswordInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isReady)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "col mt-3",
                    style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2 })
                  }, " パスワードリセット ", 4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-4" }, "新しいパスワード", -1)),
                  _createVNode(_component_PasswordInput, {
                    class: "col-8",
                    password: _ctx.password,
                    "onUpdate:password": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                  }, null, 8, ["password"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-4" }, "パスワード確認", -1)),
                  _createVNode(_component_PasswordInput, {
                    class: "col-8",
                    password: _ctx.confirmPassword,
                    "onUpdate:password": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event))
                  }, null, 8, ["password"])
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row mt-3" }, [
                  _createElementVNode("div", { class: "col-4" }),
                  _createElementVNode("div", {
                    class: "col-8",
                    style: {"display":"flex","justify-content":"left","font-size":"14px","padding":"0"}
                  }, "パスワードは12文字以上でご設定をお願いいたします。")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "col-8 btn btn-primary",
                    disabled: !_ctx.canSubmit(),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                  }, " リセット ", 8, _hoisted_8)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.warningMessage), 1)
          ])
        ])
      ])
    ]),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "mb-2" }, "パスワードを更新しました", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-1" }, "新しいパスワードでログインしてください。", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.countdown) + "秒後に自動でログイン画面へ移動します", 1),
            _createElementVNode("button", {
              class: "btn btn-primary w-100",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
            }, " ログイン画面へ ")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}